<div class="aem-Grid aem-Grid--12 aem-Grid--default--12">
  <div class="responsivegrid aem-GridColumn aem-GridColumn--default--12">
    <div *ngIf="loading" class="row">
      <div class="col-lg-12 col-md-12">
        <div class="loading-div-tiny" id="fp-loading">
          <div class="loading-spinner">
            <div alt="Loading..." class="large progress">
              <div class="prog1">
                <div class="prog2"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="isAPIError; else defaultDisplay">
      <app-partners-error [errorMessage]="errorMessage"></app-partners-error>
    </div>
    <ng-template #defaultDisplay>
      <div *ngIf="!loading" class="aem-Grid aem-Grid--12 aem-Grid--default--12">
        <div
          class="subscription-registration aem-GridColumn aem-GridColumn--default--12 subscription-registration-wrapper">
          <div class="full-bleed-row subscription-min-height">
            <div class="snap-eligibility-container d-flex justify-content-center">
              <div class="partner-logo-container ada-focus">
                <div class="subscription-registration__logo-container fresh-pass__logo-container mx-sm-5 px-sm-3 row d-flex flex-column flex-sm-row align-items-center ada-focus
                          ">
                  <img alt="{{ logoAltText }}"
                    class="col-sm-5 fresh-pass__logo-container__logo-image fresh-pass__logo align-self-cente ada-focus"
                    src="https://images.albertsons-media.com/is/image/ABS/freshpass-logo?$lplogo$&defaultImage=Not_Available">
                  <span class="col-sm-2 image-plus-icon-style align-self-center py-4 ada-focus">+</span>
                  <img alt="{{ partnerName }} logo"
                    class="col-sm-5 fresh-pass__logo-container__logo-image partner__logo align-self-cente ada-focus"
                    src="{{partnerLogo}}">
                </div>
                <div class="campaign-title-content ada-focus">
                  <h1 role="heading" aria-level="1" class="campaign-title-text ada-focus">
                    [{{[heading]}} <s class="campaign-title-oldPrice">{{regularFee}}</s> {{discountPrice}}]
                  </h1>
                </div>
                <div class="ada-focus" attr.aria-label="{{description}}">
                  <div class="campaign-text-content ada-focus" aria-hidden="true">
                    {{description}}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="experiencefragment aem-GridColumn aem-GridColumn--default--12">
          <div class="container p0 clear-fix mb24" role="region">
            <app-partners-banners [partnersData]="discountPayload" [discountCode]="discountCode"></app-partners-banners>
          </div>
        </div>

        <div class="experiencefragment aem-GridColumn aem-GridColumn--default--12">
          <div class="column-control aem-GridColumn aem-GridColumn--default--12">
            <div class="column-control-wrapper ">
              <div class="row col-md-auto">
                <div class="container-fluid">
                  <div class="row abs-no-gutters">
                    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" id="slim-padding">
                      <div class="faq-container experiencefragment section">
                        <div *ngIf="showFrequentlyAskedQuestion">
                          <app-partners-faq [faqData]="frequentlyAskedQuestion"></app-partners-faq>
                        </div>
                      </div>
                      <div class="terms-container experiencefragment section">
                        <app-partners-terms [termsContent]="termsContent">
                        </app-partners-terms>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </div>
</div>